<template>
  <div class="wrapper">
	<headerTag />
    <div class="listMain">
		<ul class="listNav">
			<li @click="cur=0" :class="{active:cur==0}">
				<img src="../../assets/images/list/list_icon1.png" alt="" />
				<p>工商服务</p>
			</li>
			<li @click="cur=1" :class="{active:cur==1}">
				<img src="../../assets/images/list/list_icon2.png" alt="" />
				<p>开户服务</p>
			</li>
			<li @click="cur=2" :class="{active:cur==2}">
				<img src="../../assets/images/list/list_icon3.png" alt="" />
				<p>财税服务</p>
			</li>
			<li @click="cur=3" :class="{active:cur==3}">
				<img src="../../assets/images/list/list_icon4.png" alt="" />
				<p>其他服务</p>
			</li>
		</ul>
		<div class="listTab">
			<ul class="listTab_ul" v-show="cur==0">
				<li>
					<router-link to="/product/product-gszc">
						<img src="../../assets/images/list/gszc.png" alt="" />
						<p>
							<span>公司注册</span>
							<span>
								<i v-if="gszcPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{gszcPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-kzba'>
						<img src="../../assets/images/list/kzba.png" alt="" />
						<p>
							<span>刻章备案</span>
							<span>
								<i v-if="kzbaPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{kzbaPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-ndhsqj'>
						<img src="../../assets/images/list/ndhsqj.png" alt="" />
						<p>
							<span>年度汇算清缴</span>
							<span>
								<i v-if="ndhsqjPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{ndhsqjPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-gszx'>
						<img src="../../assets/images/list/gszx.png" alt="" />
						<p>
							<span>公司注销</span>
							<span>
								<i v-if="gszxPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{gszxPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-qybg'>
						<img src="../../assets/images/list/qybg.png" alt="" />
						<p>
							<span>企业变更</span>
							<span>
								<i v-if="qybgPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{qybgPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-ndgsnb'>
						<img src="../../assets/images/list/ndgsnb.png" alt="" />
						<p>
							<span>年度工商年报</span>
							<span>
								<i v-if="ndgsnbPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{ndgsnbPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-xggszc'>
						<img src="../../assets/images/list/xggszc.png" alt="" />
						<p>
							<span>香港公司注册</span>
							<span>
								<i v-if="xggszcPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{xggszcPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-dzyccl'>
						<img src="../../assets/images/list/dzyccl.png" alt="" />
						<p>
							<span>地址异常处理</span>
							<span>
								<i v-if="dzycclPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{dzycclPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-xggszx'>
						<img src="../../assets/images/list/xggszx.png" alt="" />
						<p>
							<span>香港公司注销</span>
							<span>
								<i v-if="xggszxPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{xggszxPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
			</ul>
			<ul class="listTab_ul" v-show="cur==1">
				<li>
					<router-link to='/product/product-ksjbh'>
						<img src="../../assets/images/list/ksjbh.png" alt="" />
						<p>
							<span>开设基本户</span>
							<span>
								<i v-if="ksjbhPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{ksjbhPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-sbkh'>
						<img src="../../assets/images/list/sbkh.png" alt="" />
						<p>
							<span>社保开户</span>
							<span>
								<i v-if="sbkhPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{sbkhPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-ksybh'>
						<img src="../../assets/images/list/ksybh.png" alt="" />
						<p>
							<span>开设一般户</span>
							<span>
								<i v-if="ksybhPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{ksybhPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-ksgjjzh'>
						<img src="../../assets/images/list/gjjzh.png" alt="" />
						<p>
							<span>开设公积金账户</span>
							<span>
								<i v-if="ksgjjzhPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{ksgjjzhPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
			</ul>
			<ul class="listTab_ul" v-show="cur==2">
				<li>
					<router-link to='/product/product-dljz'>
						<img src="../../assets/images/list/dljz.png" alt="" />
						<p>
							<span>代理记账</span>
							<span>
								<i v-if="dljzPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{dljzPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-swch'>
						<img src="../../assets/images/list/swch.png" alt="" />
						<p>
							<span>税务筹划</span>
							<span>
								<i v-if="swchPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{swchPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-cszx'>
						<img src="../../assets/images/list/cszx.png" alt="" />
						<p>
							<span>财税咨询</span>
							<span>
								<i v-if="cszxPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{cszxPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-dzdjzfa'>
						<img src="../../assets/images/list/dzdljz.png" alt="" />
						<p>
							<span>定制代记账方案</span>
							<span>
								<i v-if="dzdjzPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{dzdjzPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-swjf'>
						<img src="../../assets/images/list/swjf.png" alt="" />
						<p>
							<span>税务解非</span>
							<span>
								<i v-if="swjfPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{swjfPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-kpzx'>
						<img src="../../assets/images/list/kpzx.png" alt="" />
						<p>
							<span>开票咨询</span>
							<span>
								<i v-if="kpzxPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{kpzxPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-jzsl'>
						<img src="../../assets/images/list/jzsl.png" alt="" />
						<p>
							<span>旧账梳理</span>
							<span>
								<i v-if="jzslPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{jzslPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-nbycjf'>
						<img src="../../assets/images/list/nbycjf.png" alt="" />
						<p>
							<span>年报异常解非</span>
							<span>
								<i v-if="nbycjfPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{nbycjfPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-fpsl'>
						<img src="../../assets/images/list/fpsl.png" alt="" />
						<p>
							<span>发票申领</span>
							<span>
								<i v-if="fpslPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{fpslPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-wqsmfw'>
						<img src="../../assets/images/list/wqsmfw.png" alt="" />
						<p>
							<span>外勤上门服务</span>
							<span>
								<i v-if="wqsmfwPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{wqsmfwPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
			</ul>
			<ul class="listTab_gsfw" v-show="cur==3">
				<li>
					<router-link to='/product/product-spjyxkz'>
						<img src="../../assets/images/list/spjyxkz.png" alt="" />
						<p>
							<span>食品经营许可证</span>
							<span>
								<i v-if="spjyxkzPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{spjyxkzPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-dskfwb'>
						<img src="../../assets/images/list/kfwb.png" alt="" />
						<p>
							<span>电商客服外包</span>
							<span>
								<i v-if="dskfwbPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{dskfwbPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-jwtz'>
						<img src="../../assets/images/list/jwtz.png" alt="" />
						<p>
							<span>ODI境外投资</span>
							<span>
								<i v-if="jwtzPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{jwtzPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-lwpqxkz'>
						<img src="../../assets/images/list/lwpq.png" alt="" />
						<p>
							<span>劳务派遣许可证</span>
							<span>
								<i v-if="lwpqxkzPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{lwpqxkzPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-yxcbyyba'>
						<img src="../../assets/images/list/yxcb.png" alt="" />
						<p>
							<span>游戏出版运营备案</span>
							<span>
								<i v-if="yxcbyybaPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{yxcbyybaPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
				<li>
					<router-link to='/product/product-dlysxkz'>
						<img src="../../assets/images/list/ysxkz.png" alt="" />
						<p>
							<span>道路运输许可证</span>
							<span>
								<i v-if="dlysxkzPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{dlysxkzPrice}}
								</i>
							</span>
						</p>
					</router-link>
				</li>
			</ul>
		</div>
	</div>
    <footerTag />
  </div>

</template>

<script>
  import "../../assets/css/serve.scss"
  import headerTag from '@/components/headerTag/headerTag.vue'
  import footerTag from '@/components/footerTag/footerTag.vue'

  export default {
    name: 'productPage',
    props: {
        
    },
    components: {
      footerTag,
	  headerTag
    },
	
	data(){
	    return{
	        cur:0,
			gszcPrice:'',
			kzbaPrice:'',
			ndhsqjPrice:'',
			gszxPrice:'',
			qybgPrice:'',
			ndgsnbPrice:'',
			xggszcPrice:'',
			dzycclPrice:'',
			xggszxPrice:'',
			ksjbhPrice:'',
			sbkhPrice:'',
			ksybhPrice:'',
			ksgjjzhPrice:'',
			dljzPrice:'',
			swchPrice:'',
			cszxPrice:'',
			dzdjzPrice:'',
			swjfPrice:'',
			kpzxPrice:'',
			jzslPrice:'',
			nbycjfPrice:'',
			fpslPrice:'',
			wqsmfwPrice:'',
			spjyxkzPrice:'',
			dskfwbPrice:'',
			jwtzPrice:'',
			lwpqxkzPrice:'',
			yxcbyybaPrice:'',
			dlysxkzPrice:'',
		}
	},
	methods:{
		goGszc:function(){
			this.$router.push({path:'/productPage/productGszc'})
		},
		getProductList(type){
			this.axios({
				method: 'POST',
				url:'/product/getOtherProduct',
				params:{
					type:type
				},
			}).then((res)=>{
					if(res.data.code==1000){
						let data = res.data.data;
						
						if(type==1){
							//公司注册
							if(data.gszc != null){
									this.gszcPrice=data.gszc.price;
							}else{
									this.gszcPrice='my';
							}
							//刻章备案
							if(data.kzba != null){
									this.kzbaPrice=data.kzba.price;
							}else{
									this.kzbaPrice='my';
							}
							//年度汇算清缴
							if(data.hsqj != null){
									this.ndhsqjPrice=data.hsqj.price;
							}else{
									this.ndhsqjPrice='my';
							}
							//公司注销
							if(data.gszx != null){
									this.gszxPrice=data.gszx.price;
							}else{
									this.gszxPrice='my';
							}
							//企业变更
							if(data.qybg != null){
									this.qybgPrice=data.qybg.price;
							}else{
									this.qybgPrice='my';
							}
							//年度工商年报
							if(data.gsnb != null){
									this.ndgsnbPrice=data.gsnb.price;
							}else{
									this.ndgsnbPrice='my';
							}
							//香港公司注册
							if(data.xggszc != null){
									this.xggszcPrice=data.xggszc.price;
							}else{
									this.xggszcPrice='my';
							}
							//地址异常处理
							if(data.dzyccl != null){
									this.dzycclPrice=data.dzyccl.price;
							}else{
									this.dzycclPrice='my';
							}
							//香港公司注销
							if(data.xggszx != null){
									this.xggszxPrice=data.xggszx.price;
							}else{
									this.xggszxPrice='my';
							}
						}
						
						if(type==2){
							//开设基本户
							if(data.ksjbh != null){
									this.ksjbhPrice=data.ksjbh.price;
							}else{
									this.ksjbhPrice='my';
							}
							//社保开户
							if(data.sbkh != null){
									this.sbkhPrice=data.sbkh.price;
							}else{
									this.sbkhPrice='my';
							}
							//开设一般户
							if(data.ksybh != null){
									this.ksybhPrice=data.ksybh.price;
							}else{
									this.ksybhPrice='my';
							}
							//开设公积金账户
							if(data.ksgjj != null){
									this.ksgjjzhPrice=data.ksgjj.price;
							}else{
									this.ksgjjzhPrice='my';
							} 
						}
						
						if(type==3){
							//代理记账
							if(data.dljz != null){
									this.dljzPrice=data.dljz.price;
							}else{
									this.dljzPrice='my';
							}
							//税务筹划
							if(data.swch != null){
									this.swchPrice=data.swch.price;
							}else{
									this.swchPrice='my';
							}
							//财税咨询
							if(data.cszx != null){
									this.cszxPrice=data.cszx.price;
							}else{
									this.cszxPrice='my';
							}
							//定制代记账方案
							if(data.dzdjz != null){
									this.dzdjzPrice=data.dzdjz.price;
							}else{
									this.dzdjzPrice='my';
							} 
							//税务解非
							if(data.swjf != null){
									this.swjfPrice=data.swjf.price;
							}else{
									this.swjfPrice='my';
							}
							//开票咨询
							if(data.kpzx != null){
									this.kpzxPrice=data.kpzx.price;
							}else{
									this.kpzxPrice='my';
							}
							//旧账梳理
							if(data.jzsl != null){
									this.jzslPrice=data.jzsl.price;
							}else{
									this.jzslPrice='my';
							}
							//年报异常解非
							if(data.nbycjf != null){
									this.nbycjfPrice=data.nbycjf.price;
							}else{
									this.nbycjfPrice='my';
							}
							//发票申领
							if(data.fpsl != null){
									this.fpslPrice=data.fpsl.price;
							}else{
									this.fpslPrice='my';
							}
							//外勤上门服务
							if(data.wqsm != null){
									this.wqsmfwPrice=data.wqsm.price;
							}else{
									this.wqsmfwPrice='my';
							}
						}
						if(type==4){
							//食品经营许可证
							if(data.spjy != null){
									this.spjyxkzPrice=data.spjy.price;
							}else{
									this.spjyxkzPrice='my';
							}
							//电商客服外包
							if(data.dskf != null){
									this.dskfwbPrice=data.dskf.price;
							}else{
									this.dskfwbPrice='my';
							}
							//ODI境外投资
							if(data.odi != null){
									this.jwtzPrice=data.odi.price;
							}else{
									this.jwtzPrice='my';
							}
							//劳务派遣许可证
							if(data.lwpq != null){
									this.lwpqxkzPrice=data.lwpq.price;
							}else{
									this.lwpqxkzPrice='my';
							}
							//游戏出版运营备案
							if(data.yxcb != null){
									this.yxcbyybaPrice=data.yxcb.price;
							}else{
									this.yxcbyybaPrice='my';
							}
							//道路运输许可证
							if(data.dlys != null){
									this.dlysxkzPrice=data.dlys.price;
							}else{
									this.dlysxkzPrice='my';
							}
						}
					}
			}).catch((err)=>{
				  this.$message.error({message: '网络异常，请稍后重试'});
			})
		}
	},
	mounted(){
		let flag = this.$route.params.flag
		if(flag == "" || flag == null){
			this.cur = 0
		}else{
			this.cur=flag
		}
		this.getProductList(1);
		this.getProductList(2);
		this.getProductList(3);
		this.getProductList(4);
	}
  }

</script>